class MybMigrationDocsUIModel {
  constructor({
    title = '',
    countryIso = '',
    countryOff = '',
    countryName = '',
    countryIata = '',
    useDefault = '',
    countryFlag = {},
    countryContent = '',
    countrylistRequirements = '',
    countryInfo = '',
    countryprocessOff = '',
    useBoardingprocess = '',
    countryprocessTitle = '',
    countryprocessImg = '',
    countryprocessInfo = '',
    formCovidImg = '',
    formCovidTitle = '',
    formCovidInfo = '',
    formCovidDetails = '',
    forBooking = '',
    bknUrlForAll = '',
    bknLinkTxt = '',
    switchMyb = 'false',
  }) {
    this.title = title;
    this.countryIso = countryIso;
    this.countryOff = countryOff;
    this.countryName = countryName;
    this.countryIata = countryIata;
    this.useDefault = useDefault;
    this.countryFlag = countryFlag;
    this.countryContent = countryContent;
    this.countrylistRequirements = countrylistRequirements;
    this.countryInfo = countryInfo;
    this.countryprocessOff = countryprocessOff;
    this.useBoardingprocess = useBoardingprocess;
    this.countryprocessTitle = countryprocessTitle;
    this.countryprocessImg = countryprocessImg;
    this.countryprocessInfo = countryprocessInfo;
    this.formCovidImg = formCovidImg;
    this.formCovidTitle = formCovidTitle;
    this.formCovidInfo = formCovidInfo;
    this.formCovidDetails = formCovidDetails;
    this.forBooking = forBooking;
    this.bknUrlForAll = bknUrlForAll;
    this.bknLinkTxt = bknLinkTxt;
    this.SwitchMyb = switchMyb === 'false' ? false : true;
  }
}

export default MybMigrationDocsUIModel;